import {DDR} from './ddr.class';

export class DDRLactatingMother3150Strategy extends DDR {
  constructor() {
    super([1300, 5, 19, 90, 120, 1.4, 1.6, 17, 2, 500, 2.8, 7, 35, 550, 1000, 45, 1300, 3, 290, 9, 320, 2.6, 700, 70, 12]);
  }
}
